module.exports = __webpack_public_path__ + "img/58b22bc.jpg";